import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/index.scss';
// import reportWebVitals from './reportWebVitals';

const fontCodes = {
	'localhost': 'GgDiUFZARPWORLfmZZzGDU50Rh82DtiB',
	'dev.plateau.bassdrum.dev': 'pXT07VhBFKYqaeuzBUQrsVj8r54BclIM',
	'plateau.bassdrum.dev': 'LDrkE9utW3gy1tgwYn8QPCZ7FCH8RQUg',
	'www.mlit.go.jp': '7SLOoBaPpD0atqOg8kfXJ0LLFpCThbe7',
}

let fontCode = fontCodes[window.location.host.replace(/:.*?$/, '')];
if(!fontCode) fontCode = fontCodes['localhost'];

let fontScript = document.createElement('script');
fontScript.src = 'https://font.realtype.jp/api/script/v4';
fontScript.setAttribute('data-rt-user', fontCode);
// document.head.
document.body.appendChild(fontScript);

ReactDOM.render(
	<React.Fragment>
	  <App />
	</React.Fragment>
	,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
